<template>
<div style="background:#fcfcfd">
   <div class="container" style="margin-bottom:20px;">
        <div style="padding-top:20px"><span style="cursor:pointer" @click="gotoHome()">HOME</span> - PRODUCT - {{name}}</div>
        <div class="row" style="padding-top:15px">
            <div class="col-md-3">
                <left></left>
            </div>
            <div class="col-md-9">
                <div class="row" style="margin-top:10px">
                    <div class="col-md-5">
                        <img v-if="id=='1140' || id == '1141' || id =='1142'" src="/static/images/product/product114_logo.jpg" style="width:90%;box-shadow:0px 0px 10px #ddd;border-radius:3px"/>

                        <img v-if="id=='114'" src="/static/images/product/product114_logo.jpg" style="width:90%;box-shadow:0px 0px 10px #ddd;border-radius:3px"/>
                        <img v-if="id=='118'" src="/static/images/product/product118_logo.jpg" style="width:90%;box-shadow:0px 0px 10px #ddd;border-radius:3px"/>
                        <img v-if="id=='115' || id == '1151'" src="/static/images/product/product115_logo.jpg" style="width:90%;box-shadow:0px 0px 10px #ddd;border-radius:3px"/>
                        <img v-if="id=='117'" src="/static/images/product/product117_logo.jpg" style="width:90%;box-shadow:0px 0px 10px #ddd;border-radius:3px"/>

                        <img v-if="id!='1142' &&id!='1141' &&id!='1140' &&id!='117' &&id!='114'&&id!='118'&&id!='115'&&id!='1151'" :src="'/static/images/product/product'+id+'_logo.png'" style="width:90%;box-shadow:0px 0px 10px #ddd;border-radius:3px"/>
                    </div>
                    <div class="col-md-7">
                        <h2 class="text-primary" style="color:#526193 !important">{{name}}</h2>

                        <div>
                            <!-- <div style="margin-top:30px" v-if="id == '114'">
                                <table style="font-size:14px;color:#666;width:320px">
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">MF:  </td>
                                        <td style="padding:5px 10px;color:#526193">Al(OH)<sub>3</sub></td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">CAS No.:</td>
                                        <td style="padding:5px 10px;color:#526193;">21645-51-2</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Appearance:</td>
                                        <td style="padding:5px 10px;color:#526193;">White powder</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">Purity: </td>
                                        <td style="padding:5px 10px;color:#526193;">99% min</td>
                                    </tr>
                                </table>
                            </div> -->

                            <div style="margin-top:30px" v-if="id == '1140' || id == '1141' || id =='1142' || id =='114'">
                                <table style="font-size:14px;color:#666;width:320px">
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">{{ $t('product_1') }}:  </td>
                                        <td style="padding:5px 10px;color:#526193">Al(OH)<sub>3</sub></td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">{{ $t('product_2') }}:</td>
                                        <td style="padding:5px 10px;color:#526193;">21645-51-2</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">{{ $t('product_3') }}:</td>
                                        <td style="padding:5px 10px;color:#526193;">{{ $t('product_8') }}</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">{{ $t('product_4') }}: </td>
                                        <td style="padding:5px 10px;color:#526193;">281830000</td>
                                    </tr>
                                </table>
                            </div>

                            <div style="margin-top:30px" v-if="id == '56'">
                                <table style="font-size:14px;color:#666;width:320px">
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">MF:  </td>
                                        <td style="padding:5px 10px;color:#526193">Mg(oh)2</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">CAS No.:</td>
                                        <td style="padding:5px 10px;color:#526193;">1309-48-4</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Appearance:</td>
                                        <td style="padding:5px 10px;color:#526193;">White powder</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">Purity: </td>
                                        <td style="padding:5px 10px;color:#526193;">96% min</td>
                                    </tr>
                                </table>
                            </div>

                            <!-- <div style="margin-top:30px" v-if="id == '57'">
                                <table style="font-size:14px;color:#666;width:320px">
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Lead oxide content:  </td>
                                        <td style="padding:5px 10px;color:#526193">30% ~ 50%</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">Melting Point:</td>
                                        <td style="padding:5px 10px;color:#526193;">70 min</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Appearance:</td>
                                        <td style="padding:5px 10px;color:#526193;">White Flake</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">Moisture: </td>
                                        <td style="padding:5px 10px;color:#526193;">0.5% max</td>
                                    </tr>
                                </table>
                            </div> -->

                            <div style="margin-top:30px" v-if="id == '571' || id == '57'">
                                <table style="font-size:14px;color:#666;width:320px">
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">{{ $t('product_6') }}:  </td>
                                        <td style="padding:5px 10px;color:#526193">{{ $t('product_10') }}</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">{{ $t('product_7') }}:</td>
                                        <td style="padding:5px 10px;color:#526193;">70-120 ℃</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">{{ $t('product_3') }}:</td>
                                        <td style="padding:5px 10px;color:#526193;">{{ $t('product_9') }}</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">{{ $t('product_4') }}: </td>
                                        <td style="padding:5px 10px;color:#526193;">38123090</td>
                                    </tr>
                                </table>
                            </div>

                            <div style="margin-top:30px" v-if="id == '66'">
                                <table style="font-size:14px;color:#666;width:320px">
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">MF:  </td>
                                        <td style="padding:5px 10px;color:#526193">BaSO4</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">CAS No.:</td>
                                        <td style="padding:5px 10px;color:#526193;">7727-43-7</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Appearance:</td>
                                        <td style="padding:5px 10px;color:#526193;">White powder</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">HS Code: </td>
                                        <td style="padding:5px 10px;color:#526193;">2833270000</td>
                                    </tr>
                                </table>
                            </div>

                            <div style="margin-top:30px" v-if="id == '63'">
                                <table style="font-size:14px;color:#666;width:320px">
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">MF:  </td>
                                        <td style="padding:5px 10px;color:#526193">C2H4N4O2</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">CAS No.:</td>
                                        <td style="padding:5px 10px;color:#526193;">123-77-3</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Appearance:</td>
                                        <td style="padding:5px 10px;color:#526193;">Pale yellow powder</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">Purity: </td>
                                        <td style="padding:5px 10px;color:#526193;">99%</td>
                                    </tr>
                                </table>
                            </div>

                            <div style="margin-top:30px" v-if="id == '118'">
                                <table style="font-size:14px;color:#666;width:320px">
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">MF:  </td>
                                        <td style="padding:5px 10px;color:#526193">CH2-CHCLn</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">CAS No.:</td>
                                        <td style="padding:5px 10px;color:#526193;">9002-86-2</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">HS Code:</td>
                                        <td style="padding:5px 10px;color:#526193;">39041000</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">Purity: </td>
                                        <td style="padding:5px 10px;color:#526193;">99%</td>
                                    </tr>
                                </table>
                            </div>

                            <div style="margin-top:30px" v-if="id == '117'">
                                <table style="font-size:14px;color:#666;width:320px">
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">MF:  </td>
                                        <td style="padding:5px 10px;color:#526193">C8H6O4</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">CAS No.:</td>
                                        <td style="padding:5px 10px;color:#526193;">100-21-0</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">EINECS No.:</td>
                                        <td style="padding:5px 10px;color:#526193;">202-830-0</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">Purity: </td>
                                        <td style="padding:5px 10px;color:#526193;">99%</td>
                                    </tr>
                                </table>
                            </div>

                            <div style="margin-top:30px" v-if="id == '108'">
                                <table style="font-size:14px;color:#666;width:320px">
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">MF:  </td>
                                        <td style="padding:5px 10px;color:#526193">SiO2</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">CAS No.:</td>
                                        <td style="padding:5px 10px;color:#526193;">112945-52-5</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Appearance:</td>
                                        <td style="padding:5px 10px;color:#526193;">White Powder </td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">Purity: </td>
                                        <td style="padding:5px 10px;color:#526193;">99.8%</td>
                                    </tr>
                                </table>
                            </div>

                            <div style="margin-top:30px" v-if="id == '70'">
                                <table style="font-size:14px;color:#666;width:320px">
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">MF:  </td>
                                        <td style="padding:5px 10px;color:#526193">C2H4N4</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">CAS No.:</td>
                                        <td style="padding:5px 10px;color:#526193;">461-58-5</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">EINECS No.:</td>
                                        <td style="padding:5px 10px;color:#526193;">207-312-8</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">Appearance: </td>
                                        <td style="padding:5px 10px;color:#526193;">White crystal powder</td>
                                    </tr>
                                </table>
                            </div>

                             <div style="margin-top:30px" v-if="id == '79'">
                                <table style="font-size:14px;color:#666;width:320px">
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">MF:  </td>
                                        <td style="padding:5px 10px;color:#526193">[AL2(OH)LnCL6-n]m</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">CAS No.:</td>
                                        <td style="padding:5px 10px;color:#526193;">1327-41-9</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">EINECS No.:</td>
                                        <td style="padding:5px 10px;color:#526193;">215-477-2</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">Appearance: </td>
                                        <td style="padding:5px 10px;color:#526193;">Yellow powder</td>
                                    </tr>
                                </table>
                            </div>

                            <div style="margin-top:30px" v-if="id == '59'">
                                <table style="font-size:14px;color:#666;width:320px">
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">MF:  </td>
                                        <td style="padding:5px 10px;color:#526193">[CH2-CHCl-CH2-CH2]n</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">CAS No.:</td>
                                        <td style="padding:5px 10px;color:#526193;">63231-66-3</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Purity:</td>
                                        <td style="padding:5px 10px;color:#526193;">99.9%</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">Appearance: </td>
                                        <td style="padding:5px 10px;color:#526193;">White powder</td>
                                    </tr>
                                </table>
                            </div>

                            <!-- <div style="margin-top:30px" v-if="id == '115'">
                                <table style="font-size:14px;color:#666;width:320px">
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">Chemical name: </td>
                                        <td style="padding:5px 10px;color:#526193;">Boron Nitride</td>
                                    </tr>
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">MF:  </td>
                                        <td style="padding:5px 10px;color:#526193">BN</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">CAS No.:</td>
                                        <td style="padding:5px 10px;color:#526193;">10043-11-5</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Appearance:</td>
                                        <td style="padding:5px 10px;color:#526193;">White powder</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">Purity: </td>
                                        <td style="padding:5px 10px;color:#526193;">98%, 99%</td>
                                    </tr>
                                </table>
                            </div> -->

                            <div style="margin-top:30px" v-if="id == '1151' || id == '115'">
                                <table style="font-size:14px;color:#666;width:320px">
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">{{ $t('product_5') }}: </td>
                                        <td style="padding:5px 10px;color:#526193;">{{ $t('home_product_section_2') }}</td>
                                    </tr>
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">{{ $t('product_1') }}:  </td>
                                        <td style="padding:5px 10px;color:#526193">BN</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">{{ $t('product_2') }}:</td>
                                        <td style="padding:5px 10px;color:#526193;">10043-11-5</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">{{ $t('product_3') }}:</td>
                                        <td style="padding:5px 10px;color:#526193;">{{ $t('product_8') }}</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">{{ $t('product_4') }}: </td>
                                        <td style="padding:5px 10px;color:#526193;">2850001900</td>
                                    </tr>
                                </table>
                            </div>

                            <div style="margin-top:30px" v-if="id == '69'">
                                <table style="font-size:14px;color:#666;width:320px">
                                  
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">MF:  </td>
                                        <td style="padding:5px 10px;color:#526193">Na2H2P2O7</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">CAS No.:</td>
                                        <td style="padding:5px 10px;color:#526193;">7758-16-9</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Appearance:</td>
                                        <td style="padding:5px 10px;color:#526193;">White powder</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">EINECS: </td>
                                        <td style="padding:5px 10px;color:#526193;">231-835-0</td>
                                    </tr>
                                </table>
                            </div>

                            <div style="margin-top:30px" v-if="id == '107'">
                                <table style="font-size:14px;color:#666;width:320px">
                                  
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Chemical name:  </td>
                                        <td style="padding:5px 10px;color:#526193">Boron Nitride Coating</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">Packing:</td>
                                        <td style="padding:5px 10px;color:#526193;">Barrels</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Appearance:</td>
                                        <td style="padding:5px 10px;color:#526193;">White emulsion</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">Solid content: </td>
                                        <td style="padding:5px 10px;color:#526193;">25% ~ 30%</td>
                                    </tr>
                                </table>
                            </div>

                            <div style="margin-top:30px" v-if="id == '106'">
                                <table style="font-size:14px;color:#666;width:320px">
                                  
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Chemical name:  </td>
                                        <td style="padding:5px 10px;color:#526193">Black Silicon Carbide</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">MF:</td>
                                        <td style="padding:5px 10px;color:#526193;">SiC</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Appearance:</td>
                                        <td style="padding:5px 10px;color:#526193;">Black Granula</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">Application: </td>
                                        <td style="padding:5px 10px;color:#526193;">Abrasive</td>
                                    </tr>
                                </table>
                            </div>

                            <div style="margin-top:30px" v-if="id == '60'">
                                <table style="font-size:14px;color:#666;width:320px">
                                  
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">MF:  </td>
                                        <td style="padding:5px 10px;color:#526193">(C2H4)n</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">CAS No:</td>
                                        <td style="padding:5px 10px;color:#526193;">9002-88-4</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Appearance:</td>
                                        <td style="padding:5px 10px;color:#526193;">White flake</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">Softening Point (℃): </td>
                                        <td style="padding:5px 10px;color:#526193;">100-110</td>
                                    </tr>
                                </table>
                            </div>

                            <div style="margin-top:30px" v-if="id == '61'">
                                <table style="font-size:14px;color:#666;width:320px">
                                  
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">MF:  </td>
                                        <td style="padding:5px 10px;color:#526193">C36H70O4Ca</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">CAS No:</td>
                                        <td style="padding:5px 10px;color:#526193;">1592-23-0</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Appearance:</td>
                                        <td style="padding:5px 10px;color:#526193;">White powder</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">Purity: </td>
                                        <td style="padding:5px 10px;color:#526193;">99.9%</td>
                                    </tr>
                                </table>
                            </div>

                            <div style="margin-top:30px" v-if="id == '96'">
                                <table style="font-size:14px;color:#666;width:320px">
                                  
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">CAS No.:  </td>
                                        <td style="padding:5px 10px;color:#526193">471-34-1</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">MF:</td>
                                        <td style="padding:5px 10px;color:#526193;">CACO3</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Appearance:</td>
                                        <td style="padding:5px 10px;color:#526193;">White powder</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">Purity: </td>
                                        <td style="padding:5px 10px;color:#526193;">99% min</td>
                                    </tr>
                                    

                                </table>
                            </div>

                            <div style="margin-top:30px" v-if="id == '71'">
                                <table style="font-size:14px;color:#666;width:320px">
                                  
                                    <tr style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Melting point: </td>
                                        <td style="padding:5px 10px;color:#526193">205-360°C</td>
                                    </tr>
                                    <tr style="border-bottom:1px solid #eee">
                                        <td  style="padding:5px 10px;font-weight:bold">Particle size:</td>
                                        <td style="padding:5px 10px;color:#526193;">300 meshes Min</td>
                                    </tr>
                                    <tr  style="background:#f5f5f5;border-bottom:1px solid #eee">
                                        <td style="padding:5px 10px;font-weight:bold">Appearance:</td>
                                        <td style="padding:5px 10px;color:#526193;">Light yellow powder</td>
                                    </tr>
                                    <tr>
                                        <td style="padding:5px 10px;font-weight:bold">Purity: </td>
                                        <td style="padding:5px 10px;color:#526193;">99% min</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="product-sub" style="margin-top:30px" v-if="id != '1142' && id !='114'&& id != '571'&& id != '1151'&& id != '115'&& id != '57' ">
                    Technical Details
                </div>
                <div>
                        <!-- <table style="width: 100%;margin-top:5px;" v-if="id == '114'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td><strong>Item</strong></td><td><strong>Standard</strong></td><td><strong>Typical value</strong></td></tr>
                                <tr class="model-row even"><td>Aluminum hydroxide,%</td><td>≥99.6</td><td>99.93</td></tr>
                                <tr class="model-row "><td>Oil Absorbency</td><td>≤29</td><td>17</td></tr>
                                <tr class="model-row even"><td>Moisture,%</td><td>≤0.1</td><td>0.02</td></tr>
                                <tr class="model-row "><td>Whiteness</td><td>≥95</td><td>97</td></tr>
                                <tr class="model-row even"><td>SiO2, %</td><td>≤0.02</td><td>0.013</td></tr>
                                <tr class="model-row "><td>Fe2O3, %</td><td>≤0.02</td><td>0.007</td></tr>
                                <tr class="model-row even"><td>Na2O, %</td><td>≤0.03</td><td>0.007</td></tr>
                                <tr class="model-row "><td>NaOH, %</td><td>≤1.0</td><td>0.024</td></tr>
                                <tr class="model-row even"><td>Particle Size</td><td></td><td>1um, 8um, 10um, 14um, 55um, 75um&nbsp;etc</td></tr>
                            </tbody>
                        </table> -->


                        <table style="width: 100%;margin-top:5px;" v-if="id == '1140'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td><strong>Category</strong></td><td><strong>Model</strong></td><td><strong>Content（%）</strong></td>
                                    <td><strong>Particle size（D50）</strong></td>
                                    <td><strong>Whiteness</strong></td>
                                    <td><strong>Moisture（%）</strong></td>
                                </tr>
                                <tr class="model-row even">
                                    <td rowspan="3">Fine Grade</td>
                                    <td>AF-1</td>
                                    <td>≥99.6</td>
                                    <td>1-2 um</td>
                                    <td>96</td>
                                    <td>≤0.25</td>
                                </tr>
                                <tr class="model-row">
                                  
                                    <td>AF-4</td>
                                    <td>≥99.6</td>
                                    <td>3-5 um</td>
                                    <td>93-97</td>
                                    <td>≤0.22</td>
                                </tr>
                                <tr class="model-row even">
                                   
                                    <td>AF-8</td>
                                    <td>≥99.6</td>
                                    <td>8-10 um</td>
                                    <td>93-97</td>
                                    <td>≤0.20</td>
                                </tr>
                       
                                <tr class="model-row">
                                    <td rowspan="4" style="background: white;">High Whiteness</td>
                                    <td>AH-14</td>
                                    <td>≥99.6</td>
                                    <td>14 um</td>
                                    <td>97</td>
                                    <td>≤0.30</td>
                                </tr>
                                <tr class="model-row even">
                                   
                                    <td>AH-25</td>
                                    <td>≥99.6</td>
                                    <td>25 um</td>
                                    <td>97</td>
                                    <td>≤0.20</td>
                                </tr>
                                <tr class="model-row">
                                
                                    <td>AH-50</td>
                                    <td>≥99.6</td>
                                    <td>50 um</td>
                                    <td>97</td>
                                    <td>≤0.15</td>
                                </tr>
                                <tr class="model-row even">
                                   
                                    <td>AH-75</td>
                                    <td>≥99.6</td>
                                    <td>75 um</td>
                                    <td>97</td>
                                    <td>≤0.15</td>
                                </tr>
                                <tr class="model-row">
                                    <td rowspan="2" style="background: white;">Normal Grade</td>
                                    <td>AN-W</td>
                                    <td>≥99.5</td>
                                    <td>70-90 um</td>
                                    <td>89</td>
                                    <td>3-5</td>
                                </tr>
                                <tr class="model-row even">
                                   
                                    <td>AN-D</td>
                                    <td>≥99.5</td>
                                    <td>70-90 um</td>
                                    <td>89</td>
                                    <td>≤0.35</td>
                                </tr>



                            </tbody>
                        </table>

                        <table style="width: 100%;margin-top:5px;" v-if="id == '1141'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td><strong>Category</strong></td><td><strong>Model</strong></td><td><strong>Content</strong></td>
                                    <td><strong>Particle size</strong></td>
                                    <td><strong>Whiteness</strong></td>
                                    <td><strong>Moisture</strong></td>
                                </tr>
                                <tr class="model-row even">
                                    <td rowspan="3"><strong>Fine Grade</strong></td>
                                    <td>AF-1</td>
                                    <td>≥99.6%</td>
                                    <td>1-2um</td>
                                    <td>96</td>
                                    <td>≤0.25%</td>
                                </tr>
                                <tr class="model-row">
                                  
                                    <td>AF-4</td>
                                    <td>≥99.6%</td>
                                    <td>3-5um</td>
                                    <td>93-97</td>
                                    <td>≤0.22%</td>
                                </tr>
                                <tr class="model-row even">
                                   
                                    <td>AF-8</td>
                                    <td>≥99.6%</td>
                                    <td>8-10um</td>
                                    <td>93-97</td>
                                    <td>≤0.20%</td>
                                </tr>
                       
                                <tr class="model-row">
                                    <td rowspan="4" style="background: white;"><strong>High Whiteness</strong></td>
                                    <td>AH-14</td>
                                    <td>≥99.6%</td>
                                    <td>14um</td>
                                    <td>97</td>
                                    <td>≤0.30%</td>
                                </tr>
                                <tr class="model-row even">
                                   
                                    <td>AH-25</td>
                                    <td>≥99.6%</td>
                                    <td>25um</td>
                                    <td>97</td>
                                    <td>≤0.20%</td>
                                </tr>
                                <tr class="model-row">
                                
                                    <td>AH-50</td>
                                    <td>≥99.6%</td>
                                    <td>50um</td>
                                    <td>97</td>
                                    <td>≤0.15%</td>
                                </tr>
                                <tr class="model-row even">
                                   
                                    <td>AH-75</td>
                                    <td>≥99.6%</td>
                                    <td>75um</td>
                                    <td>97</td>
                                    <td>≤0.15%</td>
                                </tr>
                                <tr class="model-row">
                                    <td rowspan="2" style="background: white;"><strong>Normal Grade</strong></td>
                                    <td>AN-W</td>
                                    <td>≥99.5%</td>
                                    <td>70-90um</td>
                                    <td>89</td>
                                    <td>3-5%</td>
                                </tr>
                                <tr class="model-row even">
                                   
                                    <td>AN-D</td>
                                    <td>≥99.5%</td>
                                    <td>70-90um</td>
                                    <td>89</td>
                                    <td>≤0.35%</td>
                                </tr>



                            </tbody>
                        </table>

                        <table style="width: 100%;margin-top:5px;" v-if="id =='56'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td>Item</td><td>Standard</td><td>Typical Value</td></tr>
                                <tr class="model-row even"><td>Mg(OH)2 , %</td><td>≥94</td><td>96.3</td></tr>
                                <tr class="model-row "><td>Particle Size</td><td>325-8000 Mesh</td><td>325-8000 Mesh</td></tr>
                                <tr class="model-row even"><td>Whiteness</td><td>≥91</td><td>93</td></tr>
                                <tr class="model-row "><td>CaO , %</td><td>≤ 2.0</td><td>0.5</td></tr>
                                <tr class="model-row even"><td>Hydrochloric acid insoluble，% </td><td>≤ 2.0</td><td>0.8</td></tr>
                                <tr class="model-row "><td>Moisture，%</td><td>≤ 0.5</td><td>0.17</td></tr>
                                <tr class="model-row even"><td>Cl， %</td><td>≤ 0.05</td><td>0</td></tr>
                                <tr class="model-row "><td>Fe， %</td><td>≤ 1.0</td><td>0.1</td></tr>
                                <tr class="model-row even"><td>75um Residue, %</td><td>≤ 0.01</td><td>0</td></tr>
                                <tr class="model-row "><td>Loss on ignition，%</td><td>≥28</td><td>30</td></tr>
                                <tr class="model-row even"><td>Modification Rate, %</td><td>≥98</td><td>99.5</td></tr>
                            </tbody>
                        </table>

                        <table style="width: 100%; margin-top:5px;" v-if= "id == '106'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td>Item</td><td>Typical value</td></tr>
                                <tr class="model-row even"><td>Appearance</td><td>Black granular</td></tr>
                                <tr class="model-row "><td>Hardness, Mohs</td><td>&gt;6</td></tr>
                                <tr class="model-row even"><td>Apparent density ,kg/M3</td><td>3.2 x 10³</td></tr>
                                <tr class="model-row "><td>Moisture,%</td><td>0.01</td></tr>
                                <tr  class="model-row even"><td>SiO2,%</td><td>28</td></tr>
                                <tr  class="model-row "><td>Al2O3,%</td><td>9.29</td></tr>
                                <tr  class="model-row even"><td>Fe2O3,%</td><td>22.1</td></tr>
                                <tr class="model-row "><td>MgO,%</td><td>4.62</td></tr>
                                <tr class="model-row even"><td>C</td><td>16.3</td></tr>
                                <tr class="model-row "><td>Particle Size (Mesh)</td><td>10-20, 20-40, 20-60,&nbsp;or as customer required</td></tr>
                            </tbody>
                        </table>

                        <table style="width: 100%; margin-top:5px;" v-if="id == '107'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td>Item</td><td>Value</td></tr>
                                <tr class="model-row even"><td>Main ingredients</td><td>Hexagonal boron nitride</td></tr>
                                <tr class="model-row "><td>Coverage area</td><td>25-30m2/L</td></tr>
                                <tr class="model-row even"><td>Adhesive</td><td>Clay</td></tr>
                                <tr class="model-row "><td>Viscosity</td><td>4000-5000CPS</td></tr>
                                <tr class="model-row even"><td>Specific gravity</td><td>1.2(g/㎝3)</td></tr>
                                <tr class="model-row "><td>Solid content</td><td>25%~30%</td></tr>
                                <tr class="model-row even"><td>Appearance</td><td>White emulsion</td></tr>
                            </tbody>
                        </table>

                        <table style="width: 100%; margin-top:5px;" v-if="id == '59'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td>Item</td><td>Standard</td><td>Typical value</td></tr>
                                <tr class="model-row even"><td>Chlorine content, %</td><td>35±2</td><td>35.8</td></tr>
                                <tr class="model-row "><td>Heat of fusion, j/g</td><td>≤2.0</td><td>1.5</td></tr>
                                <tr class="model-row even"><td>Volatile matter %</td><td>≤0.4</td><td>0.17</td></tr>
                                <tr class="model-row "><td>Residue on sieve (mesh of 0.9mm)&nbsp; %</td><td>≤2.0</td><td>0.6</td></tr>
                                <tr class="model-row even"><td>Impurity particles, pc/100g</td><td>≤60</td><td>21</td></tr>
                                <tr class="model-row "><td>Tensile strength, Mpa</td><td>≥8.0</td><td>9</td></tr>
                                <tr class="model-row even"><td>Shore hardness</td><td>≤65</td><td>52</td></tr>
                            </tbody>
                        </table>

                        <table style="width: 100%;margin-top:5px;" v-if="id == '60'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td>Item</td><td>Standard</td><td>Typical value</td></tr>
                                <tr class="model-row even"><td>Appearance</td><td>White flake</td><td>White flake</td></tr>
                                <tr class="model-row "><td>Softening point ℃</td><td>90-105</td><td>100</td></tr>
                                <tr class="model-row even"><td>Dosage (%)</td><td></td><td>3.5</td></tr>
                                <tr class="model-row "><td>Density (g/cm3)</td><td>0.90-0.93</td><td>0.91</td></tr>
                                <tr class="model-row even"><td>Average molecular weight</td><td>2000-2500</td><td>2320</td></tr>
                            </tbody>
                        </table>

                        <table style="width: 100%; margin-top:5px;" v-if="id == '96'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td>Item</td><td>Typical value</td></tr>
                                <tr class="model-row even"><td>calcium carbonate,%</td><td>≥ 98</td></tr>
                                <tr  class="model-row "><td>PH value</td><td>8.0-10.0</td></tr>
                                <tr class="model-row even"><td>Moisture,%</td><td>≤0.5</td></tr>
                                <tr class="model-row "><td>Whiteness</td><td> ≥ 96</td></tr>
                                <tr  class="model-row even"><td>Particle size</td><td>20-110 nm</td></tr>
                                <tr class="model-row "><td>Fe content, %</td><td>≤0.08</td></tr>
                                <tr class="model-row even"><td>Mn content, %    </td><td> ≤0.006</td></tr>
                                <tr class="model-row "><td>Surface treatment</td><td>stearic acid</td></tr>
                                <tr class="model-row even"><td>Oil absorption ml/100g </td><td>≤35</td></tr>
                            </tbody>
                        </table>

                        <table style="width: 100%; margin-top:5px;" v-if="id == '71'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td>Item</td><td>Standard</td><td>Typical value</td></tr>
                                <tr class="model-row even"><td>E&nbsp;(1%&nbsp;/cm)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td><td>420-1200</td><td>420-1200(Depends on grade)</td></tr>
                                <tr class="model-row "><td>Indissoluble&nbsp;substance:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td><td>0.5%max</td><td>0.35</td></tr>
                                <tr class="model-row even"><td>Solubility&nbsp;in&nbsp;water&nbsp;(25℃, g/l&nbsp;)</td><td>20-30</td><td>25</td></tr>
                                <tr class="model-row "><td>Solubility&nbsp;in&nbsp;water&nbsp;&nbsp;&nbsp;(70℃, g/l&nbsp;)</td><td>90-110</td><td>100</td></tr>
                                <tr class="model-row even"><td>Solubility&nbsp;in&nbsp;water&nbsp;(&nbsp;(95℃, g/l&nbsp;))</td><td>290-310</td><td>300</td></tr>
                                <tr class="model-row "><td>Max&nbsp;in&nbsp;ultra-violet&nbsp;range</td><td>348-350nm</td><td>349 nm</td></tr>
                            </tbody>
                        </table>

                        <table style="width: 100%; margin-top:5px;" v-if="id == '66'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td>Item</td><td>Standards</td><td>Typical Value</td></tr>
                                <tr class="model-row even"><td>Content</td><td>≥98.0%</td><td>0.982</td></tr>
                                <tr class="model-row "><td>Water soluble matter</td><td>≤0.30%</td><td>0.0011</td></tr>
                                <tr class="model-row even"><td>Acid soluble matter</td><td>≤0.60%</td><td>confirmed</td></tr>
                                <tr class="model-row "><td>PH value&nbsp;&nbsp;</td><td>6.0-9.0</td><td>8</td></tr>
                                <tr class="model-row even"><td>Iron(Fe)</td><td>≤0.004%</td><td>4E-05</td></tr>
                                <tr class="model-row "><td>Sulfide(S)</td><td>≤0.003%</td><td>1.5E-05</td></tr>
                                <tr class="model-row even"><td>Particle size distribution</td><td>Depends on grade</td><td>Depends on grade</td></tr>
                                <tr class="model-row "><td>Oil absorption</td><td>8-25%</td><td>0.19</td></tr>
                                <tr class="model-row even"><td>Whiteness&nbsp;</td><td>≥96</td><td>96</td></tr>
                            </tbody>
                        </table>

                        <table style="width: 100%;margin-top:5px;" v-if="id == '108'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td>Item</td><td>Typical value</td></tr>
                                <tr class="model-row even"><td>Silica content(based on ignited material) ,wt%</td><td>&gt;99.8%</td></tr>
                                <tr class="model-row "><td>Specific surface area (BET), m2/g   </td><td>200+-15</td></tr>
                                <tr class="model-row even"><td>Carbon content(Based on drying at 105℃ for 2 hours) ,wt%</td><td>&lt;0.15</td></tr>
                                <tr class="model-row "><td>PH-value in 4% dispersion</td><td>3.7-4.5</td></tr>
                                <tr class="model-row even"><td>Moisture loss on drying 2 hour at 105℃, wt%</td><td>&lt;1.5</td></tr>
                                <tr class="model-row "><td>Ignition loss 2 hours at 1000℃ based on material dried for 2 hours at 105℃, wt%</td><td>&lt;2.0</td></tr>
                                <tr class="model-row even"><td>Sieve residue(45um), wt%</td><td>&lt;0.04</td></tr>
                                <tr class="model-row "><td>Tamped Density(Based on drying at 105℃ for 2 hours) ,g/L</td><td>40-60</td></tr>
                            </tbody>
                        </table>

                        <table style="width: 100%; margin-top: 5px;" v-if="id == '70'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td>Item</td><td>Standard</td><td>Typical Value</td></tr>
                                <tr class="model-row even"><td>C2H4N4 Content, %</td><td>≥99.5</td><td>99.6</td></tr>
                                <tr class="model-row "><td>H2O Content, %</td><td>≤0.30</td><td>0.22</td></tr>
                                <tr class="model-row even"><td>Ash Content, %</td><td>≤0.03</td><td>0.024</td></tr>
                                <tr class="model-row "><td>M.P. (°C)</td><td>209-212</td><td>210</td></tr>
                                <tr class="model-row even"><td>Ca Content (ppm)</td><td>≤200</td><td>95</td></tr>
                            </tbody>
                        </table>

                        <table style="width: 100%; margin-top:5px;" v-if="id == '63'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td>Item</td><td>Standard</td><td>Typical value</td></tr>
                                <tr class="model-row even"><td>Appearance</td><td>Yellow powder</td><td>Yellow powder</td></tr>
                                <tr class="model-row "><td>Gas of foaming amount(ML/G)</td><td>150-240</td><td>150-240</td></tr>
                                <tr class="model-row even"><td>Average diameter(um)</td><td>8.5-10</td><td>9</td></tr>
                                <tr class="model-row "><td>Decomposition temperature,</td><td>150-220</td><td>150-220</td></tr>
                                <tr class="model-row even"><td>Moisture content(%)</td><td>0.5 max</td><td>0.12</td></tr>
                                <tr class="model-row "><td>PH</td><td></td><td>6.7</td></tr>
                                <tr class="model-row even"><td>Ash(%)</td><td>0.2 max</td><td>0.09</td></tr>
                            </tbody>
                        </table>

                        <table style="width: 100%; margin-top:5px;" v-if="id == '69'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td>Item</td><td>Specification</td><td>Typical value</td></tr>
                                <tr class="model-row even"><td>Appearance</td><td>White Powder</td><td>White Powder</td></tr>
                                <tr class="model-row "><td>Content, %</td><td>≥95</td><td>95.33</td></tr>
                                <tr class="model-row even"><td>PH of 1% water solution</td><td>3.5-5</td><td>3.98</td></tr>
                                <tr class="model-row "><td>Water insoluble, %</td><td>≤1.0</td><td>0.03</td></tr>
                                <tr class="model-row even"><td>Pb, %</td><td>≤0.0015</td><td>0.001</td></tr>
                                <tr class="model-row "><td>As, %</td><td>≤0.0003</td><td>0.00018</td></tr>
                                <tr class="model-row even"><td>F, %</td><td>≤0.005</td><td>0.002</td></tr>
                                <tr class="model-row "><td>P2O5, %</td><td></td><td>63.57</td></tr>
                                <tr class="model-row even"><td>Dryingloss %≤</td><td></td><td>0.5</td></tr>
                                <tr class="model-row "><td>Bulk density</td><td></td><td>0.85</td></tr>
                            </tbody>
                        </table>
                        <table style="width:100%;margin-top:5px;" v-if="id == '118'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193">
                                    <td>Suspension Grade</td>
                                    <td>SG3</td>
                                    <td>SG4</td>
                                    <td>SG5</td>
                                    <td>SG6</td>
                                    <td>SG7</td>
                                </tr>
                                
                                <tr class="model-row even">
                                    <td>K&nbsp;value&nbsp;</td><td>72-71</td><td>70-69</td><td>68-66</td><td>65-63</td><td>62-60</td>
                                </tr>
                                    
                                <tr class="model-row"><td>Viscosity,&nbsp;ml/g&nbsp;</td><td>135-127</td><td>126-119</td><td>118-107</td><td>106-96</td><td>95-87</td></tr>
                                <tr class="model-row even"><td>Average&nbsp;polymerization</td><td>1350-1250</td><td>1250-1150</td><td>1100-1000</td><td>950-850</td><td>950-850</td></tr>
                                <tr class="model-row"><td>Number&nbsp;of&nbsp;impurity&nbsp;particle ≤</td><td>&nbsp;30</td><td>&nbsp;30</td><td>&nbsp;30</td><td>&nbsp;30</td><td>&nbsp;40</td></tr>
                                <tr class="model-row even"><td>Volatiles&nbsp;content&nbsp;%, ≤</td><td>&nbsp;0.40</td><td>&nbsp;0.40</td><td>&nbsp;0.40</td><td>&nbsp;0.40</td><td>&nbsp;0.40</td></tr>
                            </tbody>
                        </table>

                        
                        <!-- <table style="width:100%;margin-top:5px;" v-if="id == '115'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td>Item</td><td>Standard</td><td>Typical value</td></tr>
                                <tr class="model-row even"><td>Boron Nitride Content, %</td><td>99</td><td>99.05</td></tr>
                                <tr class="model-row "><td>Structure</td><td>Hexagonal</td><td>Hexagonal</td></tr>
                                <tr  class="model-row even"><td>Free boron oxide, %</td><td>0.5</td><td>0.5</td></tr>
                                <tr  class="model-row "><td>Na2O, %</td><td>0.2 max</td><td>0.1</td></tr>
                                <tr class="model-row even"><td>MgO, %</td><td>0.05 max</td><td>0.02</td></tr>
                                <tr class="model-row "><td>Average Particle Size, um</td><td>5</td><td>5</td></tr>
                            </tbody>
                        </table> -->

                        <table style="width: 100%;margin-top:5px;" v-if="id=='117'">
                            <tbody>
                                <tr  class="model-row" style="color:white;background:#526193"><td>Item</td><td>Value</td></tr>
                                <tr class="model-row even"><td>Spontaneous ignition point</td><td>680℃</td></tr>
                                <tr  class="model-row "><td>Burning point</td><td>384~421℃</td></tr>
                                <tr class="model-row even"><td>Sublimation fever</td><td>98.4kJ/mol</td></tr>
                                <tr  class="model-row "><td>Heat of combustion</td><td>3225.9kJ/mol</td></tr>
                                <tr class="model-row even"><td>Density</td><td>1.55g/cm3</td></tr>
                            </tbody>
                        </table>

                        <!-- <table style="width: 100%; margin-top:5px;" v-if="id == '57'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td>Item</td><td>Standard</td><td>Typical value</td></tr>
                                <tr class="model-row even"><td>Appearance</td><td>White flake</td><td>White flake</td></tr>
                                <tr class="model-row "><td>Melting Point,℃</td><td>70min</td><td>72</td></tr>
                                <tr class="model-row even"><td>Moisture,%</td><td>≤0.5</td><td>0.35</td></tr>
                                <tr class="model-row "><td>Lead oxide content (PbO)</td><td></td><td>Pipe Grade: 30-33% / Profile Grade: 35-40% / Film Grade: 25% / Fitting Grade 40-45% / Sheet Grade 27-30% / Shoe Grade: 27-28% / Window Grade 50-55% / Wire Grade: 45%</td></tr>
                                <tr class="model-row even"><td>Dosage           ( suggested quantity in each 100 phr PVC resin)</td><td></td><td>Pipe: 3-4phr / Profile: 2.5-3.0phr / Film: 5.0-5.5phr / Fitting: 5.0-5.5phr / Sheet:2.5-3.0phr / Shoes: 2.5-3.0phr / Window: 5.0-5.5phr / Wire: 5.0-5.5phr</td></tr>
                            </tbody>
                        </table> -->

                        <table style="width: 100%;margin-top:5px;" v-if="id == '61'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td>Item</td><td>Standard</td><td>Typical value</td></tr>
                                <tr class="model-row even"><td>Calcium&nbsp;content, %</td><td>6.0-7.1</td><td>6.6</td></tr>
                                <tr class="model-row "><td>Moisture, %</td><td>3max</td><td>2.5</td></tr>
                                <tr class="model-row even"><td>Melting&nbsp;Point,°C</td><td>140 min</td><td>147</td></tr>
                                <tr class="model-row "><td>Fineness&nbsp;(through mesh200), %</td><td>95min</td><td>98.5</td></tr>
                                <tr class="model-row even"><td>Free&nbsp;fatty&nbsp;acid, %</td><td>0.5 Max</td><td>0.4</td></tr>
                            </tbody>
                        </table>

                        <table style="width: 100%; margin-top:5px;" v-if= "id == '79'">
                            <tbody>
                                <tr class="model-row" style="color:white;background:#526193"><td>Items</td><td>Specifications</td></tr>
                                <tr class="model-row even"><td>Aluminium oxide(Al2O3) %&nbsp;</td><td>30%min</td></tr>
                                <tr class="model-row "><td>Basicity%</td><td>70-90%</td></tr>
                                <tr class="model-row even"><td>PH (1% aqueous solution)</td><td>3.5-5.0%</td></tr>
                                <tr class="model-row "><td>Water insoluble %</td><td>0.001</td></tr>
                                <tr class="model-row even"><td>(As)/%</td><td>≤0.0002</td></tr>
                                <tr class="model-row "><td>(Pb)/%</td><td>≤0.001</td></tr>
                                <tr class="model-row even"><td>Cd(Cd)/%</td><td>≤0.0002</td></tr>
                                <tr class="model-row "><td>Cr+6 %</td><td>≤0.0005</td></tr>
                                <tr class="model-row even"><td>&nbsp; &nbsp;Hg %</td><td>≤0.00001</td></tr>
                            </tbody>
                        </table>
                </div>

                <div class="product-sub">
                    Properties
                </div>

                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '1140' || id == '1141' || id == '1142' || id == '114'">
                    <p>Aluminum Hydroxide, Al(OH)<sub>3</sub> ,also called alumina trihydrate. It has both basic and acidic properties, and closely related are aluminum oxide or alumina (Al<sub>2</sub>O<sub>3</sub>), It can be heated to 200°C and hydrated alumina can be decomposed into 66% alumina and 34% water.</p>
                    <p>With 20 years production experience, now ADA Aluminum Hydroxide products have stable and high standard quality, with super fine particle size up to 1um, high whiteness up to 97, and also with low impurities. Now our ATH chemicals are exporting to more than 20 countries, and widely used in all kinds of industrial applications, such as fire retardants, artificial marbles, water treatment, and so on.
</p>
                </div>

                <!-- <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '114'">
                    <p>Aluminum Hydroxide, Al(OH)3, archaically called hydrate of alumina or alumina trihydrate (Al2O3.3H2O), which is a non-abrasive powder with a Mohs' hardness index of 2.5 - 3.5 and a specific gravity of 2.42. It can be heated to 200°C and hydrated alumina can be decomposed into 66% alumina and 34% water.</p>
                    <p>We are professional manufacturer of Aluminum Hydroxide materials, and we are producing different grade of Aluminum Hydroxide for all kinds of industrial applications.</p>
                    <p>Our sales specialist will recommend the most suitable material for your application, and related Technical Data Sheet is available upon your request.</p>
                </div> -->

                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '70'">
                    <p>Dicyandiamide is a kind of white crystal powder,which is soluble in water and alcohol, slightly insoluble in aether and benzene, stable when dry and not flammable.</p>
                    <p>It is a material of melamine and intermediate pan of syntheticdrug,pesticides and coloring agent. It can be produced guanidine nitrate,sulfanilamide,sulfocarbanide,rubber accelerator,hardening of stell,fixing agent of dyeprinting,sizing agent,compound fertilizer,etc.</p>
                                    </div>

                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '69'">
                   <p>Sodium acid pyrophosphate, or disodium pyrophosphate, is an edible phosphoric salt that helps create leavening used for baking, such as baking powder, and prevents food discoloration, such as in raw potatoes.</p>                
                    <p>In its bulk state, such as at the manufacturing laboratory, the acidic nature of sodium acid pyrophosphate may be very hazardous upon skin or eye contact, inhalation or ingestion, causing severe inflammation.</p></div>

                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '106'">
                 <p>Black Silicon Carbide, also know as Black SiC, is produced in an electric resistance furnace from quartz sand and petroleum coke or anthracite at high temperature. The hardness and sharp particle of this material make it suitable for manufacturing of grinding wheels, coated products, wire saws, superior refractory materials and deoxide as well as for lapping, polishing and blasting.</p>
                 <p>We are professional manufacturer of Silicon Carbide, and we are producing different grade of Silicon Carbide for all kinds of industrial applications.</p>                </div>
<!-- 
                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '115'">
                   <p>Boron Nitride powder is a white solid material which has low porosity.It can be easily machined into complex shapes using standard carbide tooling. The material is anisotropic for its electrical and mechanical properties due to the platy hexagonal crystals and their orientation during the hot press consolidation.</p>                   <p></p>
                    <p>Boron Nitride also has high thermal conductivity, low thermal expansion, good thermal shock resistance, high electrical resistance, low dielectric constant and loss tangent.</p>                   
                    <p>We are professional manufacturer of Boron Nitride powders, and we are producing different grade of Boron Nitride for all kinds of industrial applications.</p>
                </div> -->

                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '1151' || id == '115'">
                    <p>Hexagonal Boron Nitride is a thermally and chemically resistant refractory compound of boron and nitrogen with the chemical formula BN. The material is anisotropic for its electrical and mechanical properties due to the platy hexagonal crystals and their orientation during the hot press consolidation.
                    </p>
                    <p>
                        Boron Nitride has high thermal conductivity, low thermal expansion, good thermal shock resistance, high electrical resistance, low dielectric constant and loss tangent.
                    </p>
                </div>

                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '117'">
                   <p>It is an organic compound and is the most prolific dicarboxylic acid. Solid at room temperature. Heating will not melt, 300℃ above sublimation. If heated in an airtight container, it melts at 427℃. Terephthalic acid is the raw material for the production of polyesters, especially polyethylene terephthalate (PET).</p>
                   <p>We are professional provider of PTA materials, and our sales specialist will recommend the most suitable material for your application, and related Technical Data Sheet is available upon your request.</p>
                </div>

                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '63'">
                   <p>Azodicarbonamide blowing agent is a kind of light yellow fine powder, which is one of the most widely used chemical blowing agents due to its non-toxic, odorless, self-extinguishing, relatively high decomposition temperature, and relatively large gas evolution properties, good dispersing in plastic and rubber.</p>           </div>


                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '66'">
                  <p>Barium sulfate is a kind of amorphous white powder or paste. It is nontoxic, insoluble in water, and slightly soluble in boiling hydrochloric acid.</p>
                  <p>It is chemically stable, with a total reduction of carbon as barium sulfide. It won't change color when meeting with hydrogen sulfide or toxic gases in the air.</p>                </div>

                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '79'">
                    <p>It is produced by the spray drying technology and the obtained product is light yellow, corresponding liquid form products is light yellow.</p>
                    <p>It is a kind of high-efficient,economical and nontoxic inorganic high-molecular compound, which is easily soluble in water. And it's accompanied with many chemical processes such as electrochemistry,coagulation, absorption and precipitation during the hydrolyzation .</p>                  
                </div>

                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '56'">
                   <p>Magnesium hydroxide is a white powder which is nontoxic, odorless, non-corrosion and with good flame retarding effect. It has good stability, decomposition temperature is about 330, especially suitable for resin processed in relative high temperature. Large amount of vapor is produced during combustion, the heat is taken away and the temperature drops. The hardness is less than that of aluminum hydroxide.</p>
                   <p>According to different applications, we are offering a wide range types of magnesium hydroxide, with different particle size\whiteness, and we can also offer natural grade or coated types as requested.</p>
                                   </div>

                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '107'">
                  <p>It is a protection coating material used in metal casting equipment and equipment molds, which has good adhesion ability for metal or ceramic materials, and to provide the most effective lubrication and protection of the interface.</p>
                  <p>Boron Nitride Coating is made by boron nitride materials by unique formula, which can achieve excellent performance in high temperature metal protection, effectively prevent the molten metal from corrosion, extend the service life of equipment and various tools, reduce the production cost.</p>
                  <p>We are professional manufacturer of Boron Nitride coating materials, and we are producing different grade of products for all kinds of industrial applications.</p>
                </div>

                 <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '96'">
               <p>Nano calcium carbonate is also called super fine calcium carbonate .It can provide some excellent functions during polymer production such as improving the hardness of the polymer, improving strength (tensile and impact) and enhancing the surface whiteness and gloss finish.</p>
               <p>At the same time, it can also greatly reduce the cost during the production of plastic and rubber products.</p>

               <p>With it's outstanding functions, nano calcium carbonate is widely used in plastics product such as cable, pipe, masterbatch, film, sheet, etc. And also used in Paint & coating,paper, water treatment, etc.</p>
               <p>We are professional manufacturer of Nano calcium carbonate powders, and we are producing different grade of Nano calcium carbonate for all kinds of industrial applications.</p>
                              </div>

                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '108'">
                    <p>Fumed silica is an extremely small particle with enormous surface area, high purity, and a tendency to form chains in the chemical manufacturing process.</p>
                    <p>Particles are formed by injecting chlorosilanes, such as silicon tetrachloride, into a flame of hydrogen and air. The ensuring reaction produces fumed silica and hydrogen chloride.</p> 
                </div>

                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '118'">
                  <p>It is white powder, and the particle size is 60-250um. It is fire retardant and self-extinguishing, with very good chemical resistance.
                  </p>               
                    <p>It is mainly used to produce soft plastic products such as artificial leather, films, and wire sheaths, as well as hard plastic products such as plates, doors and windows, pipes and valves.
                    </p>
                </div>

                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '60'">
                  <p>Polyethylene wax is a widely used raw materials which has low adhesive, high softening point and good hardness with stable chemical characteristics.</p>
                    <p>It also has good heat stability, good dispersion performance, no poison, no frost and mucous membrane.</p>
                    <p>With all the above featues, it can be used as an ideal interior & exterior lubricant, and also as a substitute for liquid paraffin, natural paraffin etc.</p>
                </div>

                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '71'">
                    <p>Optical Brightener is a kind of light yellow powder, it is hardly soluble in water, but soluble in paraffin, mineral oils and ordinary organic solvents.</p>
                    <p>There are different grade of optical brighteners such as OB grade/OB-1 grade/KSN grade /etc, each type of optical brightener can be used as good whitening agent for various application products such as plastic products, paintings, paper and textiles.

</p> 
                </div>

                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '59'">
                 <p>CPE resin is one kind of rubber high molecular material made of high-density polythene resin after chlorination reaction, which has good mechanical and chemical properties.</p>
                    <p>It is widely used in PVC plastic profile, sheet, pipe, pipe fittings, waterproof membrane, wire and cable sheathing, sealing, PVC laminated and extension of various plastics and rubber products.</p>
                </div>

                <!-- <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '57'">
                 <p>It is lead based compound stabilizer containing internal /external lubricants. Can be used for producing PVC products, such as pipe\profile\shoes\windows, etc.</p>
                 <p>It will not affect the flatness, bright andclean, even thickness of the product when the filling material has a fluctuation. Usually no other lubricants are needed during production.</p>
                    <p>According to the different equipment \ calendars \ applications, suggested dosage of PVC stablizer varies from 2.5-5.5phr (quantity needed in each 100 phr PVC resin).</p>
                </div> -->

                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '571' || id == '57'">
                  <p>ADA PVC Stabilizers are combinations of chemical additives necessary for the production of various PVC products. The stabilizer is Lead or Ca-Zn based, and also combined with lubricants and other additives, which can achieve ideal performance both for production and final products.
             </p>               
                    <p>ADA provides different models of stabilizers for applications such as: Pipes & Fittings, Wires & Cables, Window Profiles, Flooring and Films. Please contact our sales staff, we will give more product information according to your specific technical requirements.
                    </p>
                </div>

                <div style="color:#666;font-size:14px;line-height:25px;margin-top:5px;" v-if="id == '61'">
                 <p>Calcium Stearate is a kind of white fine powder, which is insoluble in water, soluble in hot ethanol and ether. It is easy to absorb, and will be decomposed to stearic acid and the relevant calcium-salt.</p>
                 <p>It is mainly performed as a good kind of PVC lubricant, and widely used in PP and PVC products.</p>
                                </div>

                <div class="product-sub" v-if="id !='1142' && id != '114'&& id != '571' && id != '1151'&& id != '57' && id != '115'">
                    <span>Main Applications</span>
                </div>
                <div class="product-sub" v-if="id =='1142' || id == '114'">
                    <span>Technical Details</span>
                </div>
                <div style="text-align:center;margin-top:5px" v-if="id != '1141' && id != '1140'&& id != '57' && id != '115'&& id != '114' && id != '1142'&& id != '571' && id != '1151'">
                    <img :src="'/static/images/product/product'+id+'_1.png'" style="width:100%"/>
                </div>
                <div style="text-align:center;margin-top:5px" v-if="id == '1141'">
                    <div class="small">
                        <img src="/static/images/product/p1141_1.png" style="width:100%"/>

                    </div>
                    <div class="row big">
                        <div class="col-md-7" style="text-align: left;font-weight:normal;color:#666">
                            <p style="font-weight:bold;margin-top:10px;">Flame Retardant</p>
                            <p style="font-size:14px">Used as flame retardant filler for PVC and Rubber products, such as wire, cable, construction material, paint, etc.
                            </p>

                            <p style="font-weight:bold;">Artificial Marble Filler</p>
                            <p style="font-size:14px">Used as fillers for the production of Artificial Marble, Solid Surface, Stone, etc.</p>

                            <p style="font-weight:bold;">Raw Material</p>
                            <p style="font-size:14px">Used as the raw material for the production of Alum, Glass, Water Treatment, etc.</p>

                        </div>
                        <div class="col-md-5"><img :src="'/static/images/product/p1141_right.png'" style="width:100%"/></div>
                    </div>
                    
                </div>

                <div style="text-align:center;margin-top:5px" v-if="id == '1140'">
                    <div class="small">
                        <img src="/static/images/product/p1141_1.png" style="width:100%"/>

                    </div>
                    <div class="row big">
                        <img src="/static/images/product/p1141_1_1.png" style="width:100%"/>
                    </div>
                    
                </div>


                <div style="text-align:center;margin-top:5px" v-if="id == '1142' ||id =='114'">
                    <div class="small">
                        <div>
                            <img src="/static/images/product/p1142_1_m.png" style="width:100%"/>
                        </div>
                        <div>
                            <img src="/static/images/product/p1142_2_m.png" style="width:100%"/>
                        </div>
                        <div>
                            <img src="/static/images/product/p1142_3_m.png" style="width:100%"/>
                        </div>

                    </div>
                    <div class="row big">
                        <div>
                            <img src="/static/images/product/p1142_1.png" style="width:100%"/>
                        </div>
                        <div>
                            <img src="/static/images/product/p1142_2.png" style="width:100%"/>
                        </div>
                        <div>
                            <img src="/static/images/product/p1142_3.png" style="width:100%"/>
                        </div>
                    </div>
                    
                </div>



                <div class="product-sub" v-if=" id != '571' && id != '1151'&& id != '57' && id != '115'">
                    Packing & Delivery
                </div>
                <div style="text-align:center;margin-top:5px" v-if="id != '1141' && id !='114' && id !='1140'&& id != '115' && id != '1142'&& id != '57'  && id != '571' && id != '1151'">
                    <img :src="'/static/images/product/product'+id+'_2.png'" style="width:100%"/>
                </div>


                <div style="text-align:center;margin-top:5px" v-if="id == '1142' || id == '114'">
                    <div class="small">
                        <div>
                            <img src="/static/images/product/p1142_packing_m.png" style="width:100%"/>
                        </div>
                    

                    </div>
                    <div class="row big">
                        <div>
                            <img src="/static/images/product/p1142_packing.png" style="width:100%"/>
                        </div>
                       
                    </div>
                    
                </div>



                <div style="text-align:center;margin-top:5px" v-if="id == '1141'">
                    <div class="small">
                        <img src="/static/images/product/p1141_2.png" style="width:100%"/>

                    </div>
                    <div class="row big">
                        <div class="col-md-7" style="text-align: left;font-weight:normal;color:#666">
                            <p style="font-weight:bold;margin-top:10px;">Packing</p>
                            <p >
                                <div style="font-size:14px">25kg,  50kg, 1000Kg bags</div>
                                <div style="font-size:14px">OEM packing service available</div>
                            </p>

                            <p style="font-weight:bold;">Loading</p>
                            <p style="font-size:14px">
                                <div style="font-size:14px">One 20ft container can load</div>
                                <div style="font-size:14px">- 14 Tons (Super fine grade)</div>
                                <div style="font-size:14px">- 24 Tons (Other grades)</div>

                            </p>

                            <p style="font-weight:bold;">Shipment</p>
                            <p style="font-size:14px">
                                <div style="font-size:14px">Fast production and delivery.</div>
                                <div style="font-size:14px">Professional worldwide shipment</div>
                            </p>

                        </div>
                        <div class="col-md-5"><img :src="'/static/images/product/p1141_right_2.png'" style="width:100%"/></div>
                    </div>
                    
                </div>

                <div style="text-align:center;margin-top:5px" v-if="id == '1140'">
                    <div class="small">
                        <img src="/static/images/product/p1141_2.png" style="width:100%"/>

                    </div>
                    <div class="row big">
                        <img src="/static/images/product/p1141_2_1.png" style="width:100%"/>
                    </div>
                    
                </div>

                <div class="product-sub" v-if="id == '571' || id == '57'">
                    Product Details
                </div>

                <div style="text-align:center;margin-top:5px" v-if="id == '571' || id == '57'">
                    <div class="small">
                        <img src="/static/images/product/p571_1_m.png" style="width:100%"/>

                    </div>
                    <div class="row big">
                        <img src="/static/images/product/p571_1.png" style="width:100%"/>
                    </div>
                </div>

                <div class="product-sub" v-if="id == '571' || id == '57'">
                    Technical Support
                </div>

                <div style="text-align:center;margin-top:5px" v-if="id == '571' || id == '57'">
                    <div class="small">
                        <img src="/static/images/product/p571_2_m.png" style="width:100%"/>

                    </div>
                    <div class="row big">
                        <img src="/static/images/product/p571_2.png" style="width:100%"/>
                    </div>
                </div>

                <div class="product-sub" v-if="id == '571' || id == '57'">
                    One-Stop Provider
                </div>

                <div style="text-align:center;margin-top:5px" v-if="id == '571' || id == '57'">
                    <div class="small">
                        <img src="/static/images/product/p571_3_m.png" style="width:100%"/>

                    </div>
                    <div class="row big">
                        <img src="/static/images/product/p571_3.png" style="width:100%"/>
                    </div>
                </div>






                <div class="product-sub" v-if="id == '1151' || id == '115'">
                    Technical Details
                </div>

                <div style="text-align:center;margin-top:5px" v-if="id == '1151'|| id == '115'">
                    <div class="small">
                        <img src="/static/images/product/p1151_1_m.png" style="width:100%"/>

                    </div>
                    <div class="row big">
                        <img src="/static/images/product/p1151_1.png" style="width:100%"/>
                    </div>
                </div>

                <div class="product-sub" v-if="id == '1151' || id == '115'">
                    Particle Distribution
                </div>

                <div style="text-align:center;margin-top:5px" v-if="id == '1151'|| id == '115'">
                    <div class="small">
                        <img src="/static/images/product/p1151_2_m.png" style="width:100%"/>

                    </div>
                    <div class="row big">
                        <img src="/static/images/product/p1151_2.png" style="width:100%"/>
                    </div>
                </div>

                <div class="product-sub" v-if="id == '1151'|| id == '115'">
                    Main Applications
                </div>

                <div style="text-align:center;margin-top:5px" v-if="id == '1151'|| id == '115'">
                    <div class="small">
                        <img src="/static/images/product/p1151_3_m.png" style="width:100%"/>

                    </div>
                    <div class="row big">
                        <img src="/static/images/product/p1151_3.png" style="width:100%"/>
                    </div>
                </div>





                <div class="product-sub">
                    Sales Contact
                </div>




                <div>
                   <div class="row" style="margin-top: 10px;">
                    <div class="col-12 col-md-6 order-md-2 " style="font-size: 15px; line-height: 30px;">
                    <div style="margin-bottom:5px">
                   <i class="bi bi-envelope-fill" style="color:#526193;margin-right:5px"></i>
                      cliff@adachemicals.com</div> <div style="margin-bottom:5px">
                   <i class="bi bi-telephone-fill" style="color:#526193;margin-right:5px"></i>
                     +86-13917648345 <span style="margin-left:3px">(WhatsApp/WeChat)</span>
</div> <div style="margin-bottom:5px"><i class="bi bi-geo-alt-fill"  style="color:#526193;margin-right:5px"></i> Room 1208, No.36, 1200 Changqing Road, <div style="position:relative;top:-5px"><span style="margin-left:23px">Pudong New Area, Shanghai</span></div></div></div> 
                   
                   <div class="col-12 col-md-6 order-md-1  aos-init aos-animate" style="font-size: 13px !important;">
                       <contact :productName="name"></contact>
                   </div> 
                  
                  
                </div>
                </div>
            </div>   
        </div>
    </div>
</div>
</template>

<script>
import left from './left';
import contact from './contact';
import bus from '../util/bus';
export default {
    data(){
        return{
            name:"Aluminum Hydroxide",
            id:"",
        }
    },
    created(){
    
    },
    mounted(){
        this.resetProduct();

        bus.$on('changeproduct',()=>{
            this.resetProduct();
        })
    },
    methods:{
        resetProduct(){
            let id = this.getSearchString("id");
            this.id = id;

            if(id == '114'){
                this.name = this.$t('home_product_section_1');
            }
            else if(id == '118'){
                this.name = "PVC Resin";
            }
            else if(id == '115'){
                this.name = this.$t('home_product_section_2');
            }
            else if(id == '1151'){
                this.name = "Boron Nitride";
            }
            else if(id == '117'){
                this.name = "Purified Terephthalic Acid";
            }
            else if(id == '69'){
                this.name = "Sodium Acid Pyrophosphate SAPP";
            }
            else if(id == '107'){
                this.name = "Boron nitride coating";
            }
            else if(id == '70'){
                this.name = "Dicyandiamide"
            }
            else if(id == '106'){
                this.name = "Silicon carbide abrasive";
            }
            else if(id == '108'){
                this.name = "Fumed Silica";
            }
            else if(id == '79'){
                this.name = "Poly Aluminium Chloride (PAC)";
            }
            else if(id == '56'){
                this.name = "Magnesium hydroxide";
            }
            else if(id == '66'){
                this.name = "Barium Sulfate";
            }
            else if(id == '661'){
                this.name = "Barium Sulfate";
            }
            else if(id == '57'){
                this.name = this.$t('home_product_section_3');
            }
            else if(id == '571'){
                this.name = "PVC Stabilizer";
            }
            else if(id == '59'){
                this.name = "CPE 135A";
            }
            else if(id == '60'){
                this.name = "PE wax";
            }
            else if(id == '61'){
                this.name = "Calcium Stearate";
            }
            else if(id == '63'){
                this.name = "ACR";
            }
            else if(id == '71'){
                this.name = "Optical brightener";
            }
            else if(id == '96'){
                this.name = "Nano calcium carbonate";
            }
        },
        getSearchString(key){
            var str = location.href.substring(location.href.indexOf('?'));
            str = str.substring(1, str.length);


            var arr = str.split("&");
            var obj = new Object();
 
            for (var i = 0; i < arr.length; i++) {
                var tmp_arr = arr[i].split("=");
                obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1]);
            }
            return obj[key];
        },
        gotoHome(){
            this.$router.push('/');
        },
        submitForm(){
            let name = this.name;
            let email = this.email;
            let phone = this.phone;
            let content = this.content;
        }
    },
    components: {
       left,
       contact
    },
};
</script>

<style>
.block-reverse2{
    background:#f9fbfd;
    padding:20px 0px;
    border-top:1px solid #f1f1f1;
    border-bottom:1px solid #f1f1f1;
}

.model-row{
    height:33px;
    font-size:14px;
    line-height:33px;
    padding:0px 10px;
    background:#f5f5f5;
    color:#666;
    border-bottom:1px solid #eee;
}

.model-row.even{
    background:#fff;
}

.model-row.empty{
    border-bottom:none;
}

.product-sub{
    color:#526193;
    font-weight:bold;
    font-size:24px;
    padding-bottom:0px;
    margin-top:30px;
}

table td{
    padding:0px 10px;
    line-height:23px;
    min-width:75px;
}

@media (max-width:600px) {
    .model-row{
        font-size:12px;
    }
}

.small{
    display: none;
}
@media (max-width:600px) {
    .small{
        display: block;
    }

    .big{
        display: none;
    }
}


</style>



// WEBPACK FOOTER //
// product.vue?e38614e0